import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

/**
 * Handles Clarity user identification only.
 * The base Clarity script is loaded directly from index.html for immediate tracking.
 */
export function MicrosoftClarity() {
  const { user } = useAuth();

  useEffect(() => {
    if (!window.clarity || !user?.id) return;

    window.clarity("identify", user.id);
    window.clarity("set", "user_id", user.id);
  }, [user?.id]);

  return null;
}
